export default defineNuxtPlugin(async () => {
  if ('serviceWorker' in navigator) {
    try {
      // Primeiro, tenta desregistrar todos os service workers existentes
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        console.log('Unregistering existing service worker:', registration.scope);
        await registration.unregister();
      }
      
      // Aguarda um pouco para garantir que o desregistro foi processado
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Registra o novo service worker
      const registration = await navigator.serviceWorker.register('/sw.js', { 
        scope: '/',
        updateViaCache: 'none' 
      });
      
      console.log('Service Worker registered successfully:', registration.scope);
      
      // Força atualização se já há um service worker ativo
      if (registration.active) {
        registration.update();
      }
      
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              console.log('New service worker installed, forcing activation');
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        }
      });
      
    } catch (error) {
      console.error('Service Worker operation failed:', error);
    }

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('Service worker controller changed, reloading page');
      window.location.reload();
    });
  }
});